import React from "react";
import { Breadcrumb } from "react-bootstrap";
import {pathNames} from "../utilities/constants";
import {routes} from "../../app/routes";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import _ from "lodash";
const BreadCrumb = (props) => {
    const navigate = useNavigate();
    const { userRole } = useSelector((state) => state.common.loggedUser);
    let currentPath = "";
    const getPathName = (name, isLastIndex) => {
        if(typeof pathNames[name] !== "undefined") {
           let returnVal = (pathNames[name] && !isLastIndex) ? `${pathNames[name]}` : pathNames[name]; 
           return returnVal;
        } else {
            
            let nameArr = decodeURIComponent(name).split(" ");
            const names = _.map(nameArr, item => {
                return  item.replaceAll("/", " ");
            });
            return `${names.join(" ")}`;

        }
        
    }
    const getPathArray = () => {
        let path ='';
        if (props.path==="/access-denied"){
            path = props.pathDenied
        }else{path = props.path}
        const pathArr = path.split("/");
        
        return _.filter(pathArr, path => path.length > 0);
    }
    const generateUrl = (parentObj, pathArr) => {
        if(_.has(parentObj, "childNavs")) {
            _.map(parentObj.childNavs, childNav => {
                generateUrl(childNav, pathArr);
            })
        } else {
            const currentUrl = pathArr?.join("/");
            if(currentUrl == parentObj?.path) {
                currentPath = currentUrl;
            }
        }
        return currentPath;
    }
    const findRouteByPath = (parentObj, targetPath) => {
        if (parentObj?.path === targetPath) return parentObj;
        if (_.has(parentObj, "childNavs")) {
            for (const childNav of parentObj.childNavs) {
                const found = findRouteByPath(childNav, targetPath);
                if (found) return found;
            }
        }
        return null;
    };
    const isNavDisabledForRole = (pathArr, index) => {
        const currentUrl = pathArr.slice(0, index + 1).join("/");
        const parentPath = _.find(routes, { path: pathArr[0] });
        if (!parentPath) return false;
        const routeObj = findRouteByPath(parentPath, currentUrl);
        // Breadcrumb-only hard disable for all users — kept separate from
        // the sidebar's `navigationDisable` flag so enabling it on a route
        // does NOT alter existing sidebar behavior.
        if (routeObj?.breadcrumbNavDisable === true) return true;
        // Disable only when EVERY role of the user is in the deny-list.
        // Hybrid users (e.g., Operation + PMO) keep access via their non-budget role.
        if (routeObj?.navigationDisableRoles && Array.isArray(userRole) && userRole.length > 0) {
            return userRole.every((role) => routeObj.navigationDisableRoles.includes(role));
        }
        return false;
    };
    const getUrl = (pathArr, index) => {
        currentPath = "";
        const parentPath = _.find(routes, {path: pathArr[0]});
        const newPathArr = pathArr.slice(0, index + 1);
        const generatedUrl = generateUrl(parentPath, newPathArr);
        if (generatedUrl && index < pathArr.length - 1 && isNavDisabledForRole(pathArr, index)) {
            return "";
        }
        return (generatedUrl && index < pathArr.length - 1) ? currentPath : "";
    }
    const pathArray = getPathArray();
    return (
        <div>
            {
                _.map(pathArray, (item, index) => {
                    if(item) {
                        const isLastIndex = index == getPathArray().length - 1;
                        let pathName = getPathName(item, isLastIndex);
                        let url = getUrl(pathArray, index);
                        
                        return <h3 className="breadCrumb">
                            {url ? <a className="breadCrumbItem" onClick={() => {navigate(url)}}>{pathName}</a> :<span>{pathName}</span> }
                            {index < pathArray.length - 1 && <span>{typeof(pathNames[item]) == "undefined" ? " - " : (pathNames[item].length == 0 ? "" : " > ") }</span>}
                            {/* <Breadcrumb.Item className="breadCrumbItem" href={url}>{pathName}</Breadcrumb.Item> */}
                             </h3>
                    }
                })
            }
        </div>
    )
}

export default BreadCrumb;